module.exports = __webpack_public_path__ + "static/img/organization-300x300.a3a282dd.jpg";